var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"6.56,0 8.54,4.11 13,4.84 9.73,7.96 10.42,12.46 6.43,10.27 2.35,12.35 3.19,7.86 0,4.63 4.5,4.05 "}));
}

Star.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"13px","height":"13px","viewBox":"0 0 13 13","style":{"enableBackground":"new 0 0 13 13"},"xmlSpace":"preserve"};

module.exports = Star;

Star.default = Star;
